import { render } from "./AppHeader.vue?vue&type=template&id=68fd86c8&scoped=true"
const script = {}

import "./AppHeader.vue?vue&type=style&index=0&id=68fd86c8&lang=scss&scoped=true"

import exportComponent from "/home/duanpengyuan/Projects/dcp-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fd86c8"]])

export default __exports__